import { UseMutateAsyncFunction, useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetAuthCodeRequestType,
  GetAuthCodeResponseType
} from '../../../services/IbUserAccountsServices/APIService/types';

import { useIbUserAccountsAPIService } from '../useIbUserAccountsAPIService';

function useGetClientAuthCodeAPI(): {
  getClientAuthCodeAPI: UseMutateAsyncFunction<
    GetAuthCodeResponseType,
    unknown,
    GetAuthCodeRequestType,
    unknown
  >;
  error: string;
  status;
} {
  const { ibUserAccountsAPIService } = useIbUserAccountsAPIService();

  const getAuthCode = (request: GetAuthCodeRequestType) => {
    return ibUserAccountsAPIService.getAuthCode(request);
  };

  const { mutateAsync, error, status } = useMutation(getAuthCode, {
    mutationKey: ['getAuthCodeAPI']
  });

  return {
    getClientAuthCodeAPI: mutateAsync,
    error: error ? getAPIErrorMessage(error) : '',
    status
  };
}

export { useGetClientAuthCodeAPI };
